import Typography from '@mui/material/Typography';

const Header = () => {
  return (
    <div className="p-24 sm:p-32 w-full border-b-1 bg-white header-components">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex flex-col items-center sm:items-start">
          <Typography className="text-24 md:text-32 font-extrabold tracking-tight leading-none">
            Estados
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default Header;
